import React from "react";
import GroupCell from "components/Tribe/Groups/GroupsHome/GroupCell";
import * as CONSTANT from "constants/text";
import ProjectPagination from "components/General/ProjectPagination";
import { paginate } from "utils/paginate";
import "components/Tribe/Friends/FriendsHome/FriendListContainer.css";
/*Group helper method to delete a group invite*/

//ref implementation of FriendListContainer.js

class GroupListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: this.props.pageSize,
      currentPage: 1,
    };
  }
  /**
   * Page change handler function
   */
  handleGroupPageChange = (page) => {
    this.setState({ currentPage: page });
  };

  /*****
   * Function for rendering the 4 different types of group lists.
   */
  renderLists(props) {
    let groupCells;
    let listLength = props.groupLists.length;
    let groupListPaginated = paginate(
      props.groupLists,
      this.state.currentPage,
      this.state.pageSize
    );

    /////////////////////////////////////////////////////////////////////////////////////////
    //INVITATIONS
    if (props.type === CONSTANT.INVITATIONS) {
      let groupMap = new Map();
      let groups = [];

      props.groupLists.forEach((elem, index) => {
        const groupUsers = groupMap.get(elem.group.id);
        if (groupUsers == null) {
          groupMap.set(elem.group.id, [elem.requester.username]);
          groups.push(elem);
        } else {
          groupUsers.push(elem.requester.username);
          groupMap.set(elem.group.id, groupUsers);
        }
      });

      // set list length
      listLength = groups.length;

      // paginate the groups list.
      let groupsPaginated = paginate(
        groups,
        this.state.currentPage,
        this.state.pageSize
      );

      groupCells = groupsPaginated.map((elem, index) => (
        <GroupCell
          key={elem.id}
          name={elem.group.name}
          groupPic={elem.group.group_pic}
          datePrefix={props.datePrefix}
          date={elem.date_sent}
          role={elem.role}
          type={CONSTANT.INVITATIONS}
          dateMessage={CONSTANT.PREFIX_RECEIVED + " "}
          inviter_username={elem.requester.full_name}
          inviteList={groupMap.get(elem.group.id)}
          /*Change page to GroupProfile and load location with state of invitation*/
          buttonAction={() =>
            this.props.history.push({
              pathname:
                "groups/" +
                CONSTANT.RECEIVED_INVITE +
                "/" +
                elem.group.id +
                "/" +
                elem.group.name,
              state: {
                sentFrom: elem.requester.username,
                full_name:elem.requester.full_name,
                inviteId: elem.id,
                inviteStatus: CONSTANT.INVITE,
                userInvited: elem.user.username,
              },
            })
          }
        />
      ));
    }
    /////////////////////////////////////////////////////////////////////////////////////////
    //REQUESTS
    // TODO: Needs to be updated to eventually work with groups. This is just copied from FriendsListContainer
    else if (props.type === CONSTANT.REQUESTS) {
      groupCells = groupListPaginated.map((elem, index) => (
        <GroupCell
          key={elem.group.id}
          name={elem.group.name}
          groupPic={elem.group.group_pic}
          date={elem.date_sent}
          datePrefix={props.datePrefix}
          type={CONSTANT.REQUESTS}
          dateMessage={CONSTANT.PREFIX_SENT + " "}
          /*Change page to GroupProfile and load location with state of request*/
          buttonAction={() =>
            this.props.history.push({
              pathname:
                "groups/" +
                CONSTANT.REVIEW +
                "/" +
                elem.group.id +
                "/" +
                elem.group.name,
              state: {
                inviteId: elem.id,
              },
            })
          }
        />
      ));
    }
    /////////////////////////////////////////////////////////////////////////////////////////
    //GROUPS
    //
    else if (props.type === CONSTANT.GROUPS) {
      groupCells = groupListPaginated.map((elem, index) => (
        <GroupCell
          key={elem.group.id}
          name={elem.group.name}
          groupPic={elem.group.group_pic}
          datePrefix={props.datePrefix}
          date={elem.date_joined}
          role={elem.role}
          type={CONSTANT.GROUPS}
          dateMessage={elem.role + CONSTANT.SINCE}
          buttonAction={() =>
            // this.props.history.push(
            //   "groups/" +
            //     CONSTANT.VIEW +
            //     "/" +
            //     elem.group.id +
            //     "/" +
            //     elem.group.name
            // )
            (window.location.pathname =
              "groups/" +
              CONSTANT.VIEW +
              "/" +
              elem.group.id +
              "/" +
              elem.group.name)
          }
        />
      ));
    } else if (props.type === CONSTANT.MEMBER) {
      groupCells = groupListPaginated.map((elem, index) => (
        <GroupCell
          key={elem.user}
          name={elem.user.full_name}
          groupPic={elem.user.profile_pic}
          groupId={props.groupId}
          datePrefix={props.datePrefix}
          date={elem.date_joined}
          friendsPic={true}
          role={elem.role}
          userRole={props.userRole}
          type={CONSTANT.GROUPS}
          dateMessage={elem.role + CONSTANT.SINCE}
          buttonAction={() =>
            window.open(
              `/profile/${CONSTANT.VIEW}/${elem.user.username}/`,
              "_self"
            )
          }
        />
      ));
    } else if (props.type === CONSTANT.ALL_GROUP_INVITATIONS) {
      let groupMap = new Map();
      let groups = [];

      props.groupLists.forEach((elem, index) => {
        const groupUsers = groupMap.get(elem.user.username);
        if (groupUsers == null) {
          groupMap.set(elem.user.username, [elem.requester.username]);
          groups.push(elem);
        } else {
          groupUsers.push(elem.requester.username);
          groupMap.set(elem.user.username, groupUsers);
        }
      });

      // set list length
      listLength = groups.length;

      // paginate the groups list.
      let groupsPaginated = paginate(
        groups,
        this.state.currentPage,
        this.state.pageSize
      );

      groupCells = groupsPaginated.map((elem, index) => (
        <GroupCell
          key={elem.id}
          name={elem.user.full_name}
          groupPic={elem.user.profile_pic}
          datePrefix={props.datePrefix}
          date={elem.date_sent}
          role={elem.role}
          friendsPic={true}
          type={CONSTANT.INVITATIONS}
          dateMessage={CONSTANT.PREFIX_SENT + " "}
          inviter_username={
            props.role === CONSTANT.MEMBER ? "" : elem.requester.full_name
          }
          inviteList={groupMap.get(elem.user.username)}
          buttonAction={() =>
            window.open(
              `/profile/group-invite/${elem.id}/${
                props.role.toLowerCase() + "-review"
              }/${elem.group.name}/${elem.group.id}/${elem.user.username}/`,
              "_self"
            )
          }
          triggerFunction={this.handleHover}
        />
      ));
    } else if (props.type === CONSTANT.ALL_GROUP_REQUESTS) {
      groupCells = groupListPaginated.map((elem, index) => (
        <GroupCell
          key={elem.id}
          name={elem.user.full_name}
          groupPic={elem.user.profile_pic}
          buttonTitle={props.buttonTitle}
          datePrefix={props.datePrefix}
          date={elem.date_sent}
          role={elem.role}
          friendsPic={true}
          type={CONSTANT.REQUESTS}
          dateMessage={CONSTANT.PREFIX_RECEIVED + " "}
          /**connect to a page to render a banner to accept/decline request */
          buttonAction={() =>
            window.open(
              `/profile/group-review/${elem.id}/${CONSTANT.RECEIVED_REQUEST}/${elem.group.name}/${elem.group.id}/${elem.user.username}/`,
              "_self"
            )
          }
        />
      ));
    } else if (props.type === CONSTANT.CHILD_GROUP_REQUEST) {
      const receivedInvites = props.groupLists.filter(
        (invite) => invite.type === CONSTANT.CHILD_GROUP_INVITATIONS
      );
      const sentInvites = props.groupLists.filter(
        (invite) => invite.type === CONSTANT.CHILD_GROUP_REQUEST
      );

      let groupMap = new Map();
      let groups = [];

      receivedInvites.forEach((elem, index) => {
        const groupUsers = groupMap.get(elem.group.id);
        if (groupUsers == null ) {
          groupMap.set(elem.group.id, [elem.requester.username]);
          groups.push(elem);
        } else {
          groupUsers.push(elem.requester.username);
          groupMap.set(elem.group.id, groupUsers);
        }
      });

      const receivedInviteCells = groups.map((elem, index) => (
        <GroupCell
          key={elem.group.name + props.child_username + elem.date_sent}
          name={elem.group.name}
          groupPic={elem.group.group_pic}
          datePrefix={props.datePrefix}
          date={elem.date_sent}
          role={elem.role}
          type={CONSTANT.INVITATIONS}
          dateMessage={CONSTANT.PREFIX_RECEIVED + " "}
          inviter_username={elem.requester.full_name}
          inviteList={groupMap.get(elem.group.id)}
          // TODO: Connect to page for parent to approve recevied invitation to child
          // buttonAction={() => alert("TODO: this will go to parent approval page")}
          buttonAction={() =>
            this.props.history.push({
              pathname:
                "groups/" +
                props.child_username +
                "/" +
                CONSTANT.GUARDIAN_REVIEW +
                "/" +
                elem.group.id +
                "/" +
                elem.group.name +
                "/" +
                elem.id,
            })
          }
        />
      ));
      const sentInviteCells = sentInvites.map((elem, index) => (
        <GroupCell
          key={elem.group.name + props.child_usename + elem.date_sent}
          name={elem.group.name}
          groupPic={elem.group.group_pic}
          date={elem.date_sent}
          datePrefix={props.datePrefix}
          dateMessage={CONSTANT.PREFIX_SENT + " "}
          inviter_username={elem.user.username}
          // TODO: Connect to page for parent to approve sent request from child
          buttonAction={() =>
            this.props.history.push({
              pathname:
                "groups/" +
                props.child_username +
                "/" +
                CONSTANT.GUARDIAN_REVIEW +
                "/" +
                elem.group.id +
                "/" +
                elem.group.name +
                "/" +
                elem.id,
            })
          }
        />
      ));
      groupCells = receivedInviteCells
        .concat(sentInviteCells)
        .sort(function (a, b) {
          var dateA = a.props.date;
          var dateB = b.props.date;

          if (dateA < dateB) {
            return 1;
          }
          if (dateA > dateB) {
            return -1;
          }
          return 0;
        });
    }
    return (
      <div>
        <div className="cell_container">{groupCells}</div>
        {listLength <= this.state.pageSize ? (
          <div></div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "30px",
            }}
          >
            <ProjectPagination
              itemsCount={listLength}
              pageSize={this.state.pageSize}
              currentPage={this.state.currentPage}
              onPageChange={this.handleGroupPageChange}
            />
          </div>
        )}
      </div>
    );
  }
  /////////////////////////////////////////////////////////////////////////////////////////
  //CHILD GROUP REQUESTS (ManageChildTribe page)
  // TODO: Needs to be updated to eventually work with groups. This code here is just copied from FriendsListContainer
  // else if (props.type === CONSTANT.CHILD_FRIEND_REQUESTS) {

  // }

  render() {
    return <div>{this.renderLists(this.props)}</div>;
  }
}

export default GroupListContainer;
